import axios from "axios";
import { APIs, API_BASE_URL, SERVICEURL, SHARED_SERVICEURL } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";


export const getStudyList = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETSTUDYLIST,
      {
        pageNumber: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: true,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403) window.location.assign("/");
    else return error.response;
  }
};

export const getPriors = async (priorListSearchDto) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETPRIORSLIST,
      {
        data: {
          priorListSearchDto,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyListByTab = async (body, id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETSTUDYLIST + "/get/" + id,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyListWithContextSwitch = async (clientId,secretKey, patientId)=>{
  const response = await axios.post(API_BASE_URL + SERVICEURL+"/open-api/loadStudyList", {
    data: {
      clientId: clientId,
      secretKey: secretKey,
      patientId: patientId
  
    },
    
  });
  return response;
}


export const getUnassignReasonCount = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETUNASSIGNREASONCOUNT,
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const submitEditPatientDetails = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/editpatient/save",
      {
        data: {
          studyEditDto: body,
        },
      }
    );
    
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const submitHistoryUploadDetails = async (body, files) => {
  const payload = JSON.stringify(body);
  var formData = new FormData();
  const blob = new Blob([payload], {
    type: "application/json",
  });

  formData.append("historyDto", blob);

  files.map((file) => {
    formData.append("files", file);
    return true;
  });
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/upload/history",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getPatientDetailsAPI = async (patientID) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/editpatient/get",
      {
        data: {
          studyId: patientID,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getUploadHistoryDetailsAPI = async (patientID, activeData, clientId, firmId, modalityId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/history/fetch",
      {
        data: {
          studyId: patientID,
          activeData,
          clientId: clientId,
          firmId: firmId,
          modalityId: modalityId
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const batchDeleteHistoryFiles = async (studyId, selectedStudies) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/history/batchdelete",
      {
        data: {
          studyId: studyId,
          selectedStudies: selectedStudies,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteHistoryFile = async (studyId, historyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/history/deletereport",
      {
        data: {
          studyId: studyId,
          studyHistoryId: historyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteStudyApi = async (studyId, deleteImageCheck) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/delete",
      {
        data: {
          studyId: studyId,
          deleteImagesOnly: deleteImageCheck
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const batchDeleteStudyApi = async (studyIds, deleteImageCheck) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/batchdelete",
      {
        data: {
          selectedStudies: studyIds,
          deleteImagesOnly: deleteImageCheck
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const batchReinferenceStudyApi = async (studyIds) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/batchretriage",
      {
        data: {
          selectedStudies: studyIds,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const ReInferenceApi = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/study/retriage",
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const CloseStudyApi = async (data) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/closestudy",
      {
        data: {
          closeStudy: data,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const RevertCloseStudyApi = async (studyId, assignmentId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL +
        SERVICEURL +
        `/revertclosedstudy/${studyId}/${assignmentId}`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addToLibraryApi = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/addtolibrary",
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const removeFromLibraryApi = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/removefromlibrary",
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const shareStudyLinkApi = async (studyId, firmId, clientId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/sharing/study/modal",
      {
        data: {
          studyId: studyId,
          firmId: firmId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const shareStudyToUsersApi = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/sharing/study/share",
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAverageTatAPI = async (modality) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/get-average-TAT/${modality}`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchPeerReviewTimeLine = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/peer/review/reviewtimeline`, 
      {
        data: {
          studyId: studyId,
        },
      }
    );
   
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};


export const fetchpendingrequestcount = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/fetchpendingrequestcount`, 
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAssignmentStausCount = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/peer/review/fetchreviewassignmentcount`, 
      {
        withCredentials: true,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const downloadDoc = async (fileName) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL +APIs.PEERREVIEWDOWNLOAD, 
      {
        data: {
          fileName: fileName,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const uploadEvaluationSheet = async (file, assignmentId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("assignmentId", assignmentId);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/peer/review/upload/evaluationsheet",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response && error.response.status === 403) {
      window.location.assign(APIs.REDIRECTLOGOUT);
    } else {
      return error.response;
    }
  }
}

export const handlePeerReviewGuideLines =async()=>{
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.DOWNLOADPEERREVIEWGUIDELINES, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const downloadSavedEvaluationSheet = async(assignmentId,filePath)=>
{
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + SERVICEURL + '/peer/review/download/savedevalutationsheet',{
      data:{
        assignmentId:assignmentId,
        filePath:filePath,
      }
    }, {
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const markEvaluationComplete =async(assignmentId,isPeerReviewEvaluator)=>{
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + SERVICEURL+ '/peer/review/markevaluationcomplete',
      {
        data: {
          assignmentId:assignmentId,
          isPeerReviewEvaluator,isPeerReviewEvaluator
        },
      } ,{
      withCredentials: true,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const showStatusAPI = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/show-status",
      {
        data: {
          studyId: payload.studyId,
          firmId: payload.firmId,
          providerId: payload.providerId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const handleUploadStudyApi = async (body, files) => {
  const payload = JSON.stringify(body);
  let formData = new FormData();
  const blob = new Blob([payload], {
    type: "application/json",
  });

  formData.append("UploadStudyDto", blob);
  formData.append("multipart", files);
  try {
    const response = axiosInterceptor
      .post(API_BASE_URL + SERVICEURL + "/upload/dicom", formData, {
        headers: {
          "Content-Type": "multi-part/form-data",
        },
      })
      .then(() => {
        console.log("successfull");
      })
      .catch(() => {
        console.log("error");
      });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const returnedStudyReasons = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + `/unassignedReason/detail/${studyId}`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const returnedStudyCountApi = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/unassignedReason",
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const exportCsvStudyApi = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/studylist/csvexport",
      {
        data: {
          studyListSearchDto: body,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//FETCH PROGRESS OF DOWNLOAD
export const fetchCsvDownloadProgress = async (token) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.FETCHCSVDOWNLOADPROGRESS,
      {
        data: {
          token,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

//DOWNLOAD COMPLETED FILE
export const downloadCompletedCsvFile = async (token) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADCOMPLETEDCSVFILE,
      {
        data: {
          token,
        },
      },
      { responseType: "arraybuffer" },
      {
        headers: {
          "content-type": "application/json",
          Accept: "*/*",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const exportCsvStudyStatusAPI = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/studylist/csvexport/status",
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getClientProviders = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/studylist/getclientproviders",
      {
        data: {
          clientProvidersMapping: body,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignProvider = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/assignprovider",
      {
        data: {
          reportingProvider: body.reportingProvider,
          baseURL: body.baseURL+"new",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignProviderByAdmin = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/assignproviderbyadmin",
      {
        data: {
          reportingProvider: body.reportingProvider,
          baseURL: body.baseURL+"new",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignMe = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/assignme/" + body.isAssign,
      {
        data: {
          reportingProvider: body.reportingProvider,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignMeSupervisor = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.SUPERVISORASSIGNME,
      {
        data: {
          reportingProviderDto: body.reportingProviderDto,
          isAssign: body.isAssign,
          isReviewer: body.isReviewer,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignMeTypist = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.TYPISTASSIGNME,
      {
        data: {
          studyId: body.studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getTimeSpendByRadiologist = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.TIMESPENDBYRADIOLOGIST,
      {
        data: {
          studyId: body.studyId,
          isParent: body.isParent,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const batchAssignProvider = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/batchassignprovider",
      {
        data: {
          reportingProviderList: body.reportingProviderList,
          baseURL: body.baseURL+"new",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const sendReportLink = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/sharing/report/link/tomail",
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const checkForSendReportField = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETFIRMDATAPRESENT,
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const sendReportAttachment = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/notification/mail/send",
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchReportLinkUrl = async (
  studyId,
  firmId,
  clientId,
  baseUrl
) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL +
        SERVICEURL +
        `/sharing/report/link/${studyId}/${firmId}?baseUrl=${baseUrl}`
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchFirmEmail = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETFIRMEMAIL,
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const viewSharedPdf = async (encrypted_id) => {
  try {
    const response = await axiosInterceptor.get(
      API_BASE_URL + SHARED_SERVICEURL + `/shared/report/view?q=${encrypted_id}`
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const reSendReportLink = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + "/shared/report/link/resend",
      {
        data: body,
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyStatus = async (studyId, assignmentId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETSTUDYSTATUS,
      {
        data: {
          studyId,
          assignmentId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getReturnStudyStatus = async (studyId, assignmentId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETRETURNSTATUS,
      {
        data: {
          studyId,
          assignmentId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const sendOldStudyAccessRequest = async (studyId, reason) => {
    try {
      const response = await axiosInterceptor.post(
        API_BASE_URL + SERVICEURL + APIs.SENDOLDSTUDYREQUEST,
        {
          data: {
            studyId,
            reason,
          },
        }
      );
      return response;
    } catch (error) {
      if (error.response.status === 403)
        window.location.assign(APIs.REDIRECTLOGOUT);
      else return error.response;
    }   
}

export const sendOldStudyAccessRequest2 = async (studyId, reason, userId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.SENDARCHIVEDSTUDYACCESSREQUEST,
      {
        data: {
          archivedStudyAccessRequest: { studyId, reason, userId },
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const checkIfActiveRequestExists = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.CHECKARCHIVEDSTUDYACCESSREQUEST,
      {
        data: {
          archivedStudyAccessRequest: { studyId },
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const reportVersionControl = async (studyId, extReportReceived) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL +
        SERVICEURL +
        `/study/report/version/${studyId}/${extReportReceived}`,
      {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const reportVersionControlMSWord = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETMSWORDREPORTHISTORY,
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getPaymentStatusOfStudy = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETPAYMENTSTATUS,
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  } 
};
export const sendReportToLIMS = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.SENDREPORTTOLIMS,
      {
        data: {
          studyId: studyId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};


export const addTypistStudy = async (accessCode) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.TYPISTADDSTUDY,
      {
        data: {
          accessCode: accessCode,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getUploadStudyClients = async (firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETUPLOADSTUDYCLIENTS,
      {
        data: {
          firmId: firmId,
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getTypistInfo = async (studyId)=>{
  try{
  const response = await axiosInterceptor.post(
    API_BASE_URL + SERVICEURL + APIs.GETTYPISTDETAILS,
    {
      data: {
        studyId: studyId,
      },
    }
  );
  return response;
} catch (error) {
  if (error.response.status === 403)
    window.location.assign(APIs.REDIRECTLOGOUT);
  else return error.response;
}
};


export const unassignTypist = async (studyId)=>{
  try{
  const response = await axiosInterceptor.post(
    API_BASE_URL + SERVICEURL + APIs.UNASSIGNTYPIST,
    {
      data: {
        studyId: studyId,
      },
    }
  );
  return response;
} catch (error) {
  if (error.response.status === 403)
    window.location.assign(APIs.REDIRECTLOGOUT);
  else return error.response;
}
}
export const getUploadStudyInitialData = async () => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETUPLOADSTUDYINITIALDATA, {}
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyInformationFromPACS = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.STUDYINFORMATIONFROMPACS, 
      {
        data:{
          studyId: studyId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const pullPacsStudyReport = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.PULLPACSSTUDYREPORT, 
      {
        data:{
          studyId: studyId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const pushImagesToPACS = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.PUSHIMAGESTOPACS, 
      {
        data:{
          studyId: studyId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getPacsNodeForSending = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETPACSNODE, 
      {
        data:{
          studyId: studyId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const sendToNodes = async (studyId, selectedNodeIds) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.SENDTOPACSNODE, 
      {
        data:{
          studyId: studyId,
          selectedNodeIds: selectedNodeIds
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getRadiologistForPeerReview = async (studyId, clientId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETRADIOLOGISTFORPEERREVIEW, 
      {
        data:{
          studyId: studyId,
          clientId: clientId,
          firmId: firmId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getEvaluatorForEvaluation = async (studyId, clientId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GETEVALUATORS, 
      {
        data:{
          studyId: studyId,
          clientId: clientId,
          firmId: firmId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignRadForPeerReview = async (studyId, selectedRadiologistId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ASSIGNFORPEERREVIEW, 
      {
        data:{
          studyId: studyId,
          selectedRadiologistd: selectedRadiologistId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignEvaluator = async (studyId, selectedRadiologistId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ASSIGNFOREVALUATION, 
      {
        data:{
          studyId: studyId,
          selectedEvaluatorId: selectedRadiologistId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getGatewayStudyStatusAPI = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.GATEWAYSTUDYSTATUS, 
      {
        data:{
          studyId: studyId
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const dataSwitchToggleAPI = async (isActiveData) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.SWITCHDATA, 
      {
        data:{
          isActiveData: isActiveData
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const downloadTrigger = async (tableName,updateOrInsert) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADTRIGGER, 
      {
        data:{
          updateOrInsert: updateOrInsert,
          tableName: tableName
        }
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const handleAcceptAcessRequest = async (studyId, userId, requestId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ACCEPTSTUDYACCESSREQUEST,
      {
        data: {
          archivedStudyAccessRequest: { studyId, userId, requestId },
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const handleRejectAcessRequest = async (studyId, userId, requestId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.REJECTSTUDYACCESSREQUEST,
      {
        data: {
          archivedStudyAccessRequest: { studyId, userId, requestId },
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};